import React from "react";

import styles from "./ArticleSubHeader.module.scss";

type Props = {
  label: string;
  subLabel: string;
};

export const ArticleSubHeader = (props: Props) => {
  return (
    <div className={styles.subHeader}>
      <div className={styles.label}>{props.label}</div>
      <div className={styles.subLabel}>{props.subLabel}</div>
      <div className={styles.border}></div>
    </div>
  );
};
